import { aboutTranslations } from './index';

const FALLBACK_LANG = 'en';

export function getAboutText(key, lang = FALLBACK_LANG) {
  const pack = aboutTranslations[lang];

  if (pack && Object.prototype.hasOwnProperty.call(pack, key)) {
    return pack[key];
  }

  const fallbackPack = aboutTranslations[FALLBACK_LANG];
  if (fallbackPack && Object.prototype.hasOwnProperty.call(fallbackPack, key)) {
    return fallbackPack[key];
  }

  return key;
}
